import { render, staticRenderFns } from "./AuthMenu.vue?vue&type=template&id=57a3bc2e&"
import script from "./AuthMenu.vue?vue&type=script&lang=js&"
export * from "./AuthMenu.vue?vue&type=script&lang=js&"
import style0 from "./AuthMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AuthMenu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports